var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "menu-nav" },
    [
      _c("router-link", {
        attrs: { to: { name: "calendar" } },
        nativeOn: {
          click: function ($event) {
            return _vm.closeOffcanvasElements()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "li",
                  {
                    staticClass: "menu-item",
                    class: [
                      isActive && "menu-item-active",
                      isExactActive && "menu-item-active",
                    ],
                    attrs: {
                      "aria-haspopup": "true",
                      "data-menu-toggle": "hover",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "menu-link",
                        attrs: { href: href },
                        on: { click: navigate },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "menu-icon feather feather-calendar",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                x: "3",
                                y: "4",
                                width: "18",
                                height: "18",
                                rx: "2",
                                ry: "2",
                              },
                            }),
                            _c("line", {
                              attrs: { x1: "16", y1: "2", x2: "16", y2: "6" },
                            }),
                            _c("line", {
                              attrs: { x1: "8", y1: "2", x2: "8", y2: "6" },
                            }),
                            _c("line", {
                              attrs: { x1: "3", y1: "10", x2: "21", y2: "10" },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("menu.calendar"))),
                        ]),
                      ]
                    ),
                    _c("i", { staticClass: "la la-angle-right" }),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("router-link", {
        attrs: { to: { name: "clients" } },
        nativeOn: {
          click: function ($event) {
            return _vm.closeOffcanvasElements()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "li",
                  {
                    staticClass: "menu-item",
                    class: [
                      isActive && "menu-item-active",
                      isExactActive && "menu-item-active",
                    ],
                    attrs: {
                      "aria-haspopup": "true",
                      "data-menu-toggle": "hover",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "menu-link",
                        attrs: { href: href },
                        on: { click: navigate },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "menu-icon feather feather-users",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2",
                              },
                            }),
                            _c("circle", {
                              attrs: { cx: "9", cy: "7", r: "4" },
                            }),
                            _c("path", {
                              attrs: { d: "M23 21v-2a4 4 0 0 0-3-3.87" },
                            }),
                            _c("path", {
                              attrs: { d: "M16 3.13a4 4 0 0 1 0 7.75" },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("menu.clients"))),
                        ]),
                      ]
                    ),
                    _c("i", { staticClass: "la la-angle-right" }),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm.$hasRole(_vm.acl.roles.owner) ||
      _vm.$hasPermission(_vm.acl.permissions.manageAccount)
        ? _c("router-link", {
            attrs: { to: { name: "services" } },
            nativeOn: {
              click: function ($event) {
                return _vm.closeOffcanvasElements()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ href, navigate, isActive, isExactActive }) {
                    return [
                      _c(
                        "li",
                        {
                          staticClass: "menu-item",
                          class: [
                            isActive && "menu-item-active",
                            isExactActive && "menu-item-active",
                          ],
                          attrs: {
                            "aria-haspopup": "true",
                            "data-menu-toggle": "hover",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "menu-link",
                              attrs: { href: href },
                              on: { click: navigate },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "menu-icon feather feather-clipboard",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                                    },
                                  }),
                                  _c("rect", {
                                    attrs: {
                                      x: "8",
                                      y: "2",
                                      width: "8",
                                      height: "4",
                                      rx: "1",
                                      ry: "1",
                                    },
                                  }),
                                ]
                              ),
                              _c("span", { staticClass: "menu-text" }, [
                                _vm._v(_vm._s(_vm.$t("menu.services"))),
                              ]),
                            ]
                          ),
                          _c("i", { staticClass: "la la-angle-right" }),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2760684870
            ),
          })
        : _vm._e(),
      _vm.$hasRole(_vm.acl.roles.owner) ||
      _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
      _vm.$hasPermission(_vm.acl.permissions.managePlace)
        ? _c("router-link", {
            attrs: { to: { name: "staff" } },
            nativeOn: {
              click: function ($event) {
                return _vm.closeOffcanvasElements()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ href, navigate, isActive, isExactActive }) {
                    return [
                      _c(
                        "li",
                        {
                          staticClass: "menu-item",
                          class: [
                            isActive && "menu-item-active",
                            isExactActive && "menu-item-active",
                          ],
                          attrs: {
                            "aria-haspopup": "true",
                            "data-menu-toggle": "hover",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "menu-link",
                              attrs: { href: href },
                              on: { click: navigate },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "menu-icon feather feather-briefcase",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("rect", {
                                    attrs: {
                                      x: "2",
                                      y: "7",
                                      width: "20",
                                      height: "14",
                                      rx: "2",
                                      ry: "2",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
                                    },
                                  }),
                                ]
                              ),
                              _c("span", { staticClass: "menu-text" }, [
                                _vm._v(_vm._s(_vm.$t("menu.staff"))),
                              ]),
                            ]
                          ),
                          _c("i", { staticClass: "la la-angle-right" }),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              827905436
            ),
          })
        : _vm._e(),
      _vm.$hasRole(_vm.acl.roles.owner) ||
      _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
      _vm.$hasPermission(_vm.acl.permissions.managePlace)
        ? _c("router-link", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: this.currentUser.isInLawIndustry,
                expression: "this.currentUser.isInLawIndustry",
              },
            ],
            attrs: { to: { name: "subjects" } },
            nativeOn: {
              click: function ($event) {
                return _vm.closeOffcanvasElements()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ href, navigate, isActive, isExactActive }) {
                    return [
                      _c(
                        "li",
                        {
                          staticClass: "menu-item",
                          class: [
                            isActive && "menu-item-active",
                            isExactActive && "menu-item-active",
                          ],
                          attrs: {
                            "aria-haspopup": "true",
                            "data-menu-toggle": "hover",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "menu-link",
                              attrs: { href: href },
                              on: { click: navigate },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "menu-icon feather feather-briefcase",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 512 512",
                                    width: "22",
                                    height: "22",
                                    fill: "#EAF0F6",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M502.6 198.6l-61.25-61.25C435.4 131.4 427.3 128 418.8 128H256C220.7 128 191.1 156.7 192 192l.0065 255.1C192 483.3 220.7 512 256 512h192c35.2 0 64-28.8 64-64l.0098-226.7C512 212.8 508.6 204.6 502.6 198.6zM464 448c0 8.836-7.164 16-16 16h-192c-8.838 0-16-7.164-16-16L240 192.1c0-8.836 7.164-16 16-16h128L384 224c0 17.67 14.33 32 32 32h48.01V448zM317.7 96C310.6 68.45 285.8 48 256 48H215.2C211.3 20.93 188.1 0 160 0C131.9 0 108.7 20.93 104.8 48H64c-35.35 0-64 28.65-64 64V384c0 35.34 28.65 64 64 64h96v-48H64c-8.836 0-16-7.164-16-16V112C48 103.2 55.18 96 64 96h16v16c0 17.67 14.33 32 32 32h61.35C190 115.4 220.6 96 256 96H317.7zM160 72c-8.822 0-16-7.176-16-16s7.178-16 16-16s16 7.176 16 16S168.8 72 160 72z",
                                    },
                                  }),
                                ]
                              ),
                              _c("span", { staticClass: "menu-text" }, [
                                _vm._v(_vm._s(_vm.$t("menu.subjects"))),
                              ]),
                            ]
                          ),
                          _c("i", { staticClass: "la la-angle-right" }),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              321618648
            ),
          })
        : _vm._e(),
      _vm.$hasRole(_vm.acl.roles.owner) ||
      _vm.$hasPermission(_vm.acl.permissions.manageAccount)
        ? _c("router-link", {
            attrs: { to: { name: "statistics" } },
            nativeOn: {
              click: function ($event) {
                return _vm.closeOffcanvasElements()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ href, navigate, isActive, isExactActive }) {
                    return [
                      _c(
                        "li",
                        {
                          staticClass: "menu-item",
                          class: [
                            isActive && "menu-item-active",
                            isExactActive && "menu-item-active",
                          ],
                          attrs: {
                            "aria-haspopup": "true",
                            "data-menu-toggle": "hover",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "menu-link",
                              attrs: { href: href },
                              on: { click: navigate },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "menu-icon feather feather-pie-chart",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M21.21 15.89A10 10 0 1 1 8 2.83",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: { d: "M22 12A10 10 0 0 0 12 2v10z" },
                                  }),
                                ]
                              ),
                              _c("span", { staticClass: "menu-text" }, [
                                _vm._v(_vm._s(_vm.$t("menu.statistics"))),
                              ]),
                            ]
                          ),
                          _c("i", { staticClass: "la la-angle-right" }),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2268846202
            ),
          })
        : _vm._e(),
      _vm.$hasRole(_vm.acl.roles.owner) ||
      _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
      _vm.$hasPermission(_vm.acl.permissions.managePlace)
        ? _c("router-link", {
            attrs: { to: { name: "settings" } },
            nativeOn: {
              click: function ($event) {
                return _vm.closeOffcanvasElements()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ href, navigate, isActive, isExactActive }) {
                    return [
                      _c(
                        "li",
                        {
                          staticClass: "menu-item",
                          class: [
                            isActive && "menu-item-active",
                            isExactActive && "menu-item-active",
                          ],
                          attrs: {
                            "aria-haspopup": "true",
                            "data-menu-toggle": "hover",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "menu-link",
                              attrs: { href: href },
                              on: { click: navigate },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "menu-icon feather feather-settings",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("circle", {
                                    attrs: { cx: "12", cy: "12", r: "3" },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z",
                                    },
                                  }),
                                ]
                              ),
                              _c("span", { staticClass: "menu-text" }, [
                                _vm._v(_vm._s(_vm.$t("menu.settings"))),
                              ]),
                            ]
                          ),
                          _c("i", { staticClass: "la la-angle-right" }),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              71250881
            ),
          })
        : _vm._e(),
      _c("router-link", {
        attrs: { to: { name: "profile" } },
        nativeOn: {
          click: function ($event) {
            return _vm.closeOffcanvasElements()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "li",
                  {
                    staticClass: "menu-item mobile-only-item",
                    class: [
                      isActive && "menu-item-active",
                      isExactActive && "menu-item-active",
                    ],
                    attrs: {
                      "aria-haspopup": "true",
                      "data-menu-toggle": "hover",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "menu-link",
                        attrs: { href: href },
                        on: { click: navigate },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "menu-icon feather feather-user",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                              },
                            }),
                            _c("circle", {
                              attrs: { cx: "12", cy: "7", r: "4" },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "menu-text" }, [
                          _vm._v(_vm._s(_vm.$t("menu.profile"))),
                        ]),
                      ]
                    ),
                    _c("i", { staticClass: "la la-angle-right" }),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "li",
        {
          staticClass: "menu-item mobile-only-item",
          attrs: { "aria-haspopup": "true", "data-menu-toggle": "hover" },
        },
        [
          _c(
            "a",
            {
              staticClass: "menu-link",
              on: {
                click: function ($event) {
                  return _vm.changeLanguage()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-globe menu-icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                  _c("line", {
                    attrs: { x1: "2", y1: "12", x2: "22", y2: "12" },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z",
                    },
                  }),
                ]
              ),
              _c("span", { staticClass: "menu-text" }, [
                _vm._v(_vm._s(_vm.currentLanguageName)),
              ]),
            ]
          ),
          _c("i", { staticClass: "la la-angle-right" }),
        ]
      ),
      _c(
        "li",
        {
          staticClass: "menu-item mobile-only-item",
          attrs: { "aria-haspopup": "true", "data-menu-toggle": "hover" },
        },
        [
          _c(
            "a",
            {
              staticClass: "menu-link",
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-log-out menu-icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" },
                  }),
                  _c("polyline", { attrs: { points: "16 17 21 12 16 7" } }),
                  _c("line", {
                    attrs: { x1: "21", y1: "12", x2: "9", y2: "12" },
                  }),
                ]
              ),
              _c("span", { staticClass: "menu-text" }, [
                _vm._v(_vm._s(_vm.$t("menu.logout"))),
              ]),
            ]
          ),
          _c("i", { staticClass: "la la-angle-right" }),
        ]
      ),
      _c("ChangeLanguageModal", { ref: "changeLanguageModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }